<button #copyButton
        class="font-small flex justify-around items-center hand-cursor"
        [matTooltip]="!isCopied  ? 'Copy to clipboard' : 'Copied!'"
        (click)="copyCommand()">
  <mat-icon [ngClass]="{'copied': isCopied}">
    {{isCopied ? 'check_circle' : 'content_copy'}}
  </mat-icon>
  <span *ngIf="buttonText">{{isCopied ? 'Copied!' : buttonText}}</span>
</button>